import { render, staticRenderFns } from "./IdeaList.vue?vue&type=template&id=ffbc33e6&scoped=true"
import script from "./IdeaList.vue?vue&type=script&lang=js"
export * from "./IdeaList.vue?vue&type=script&lang=js"
import style0 from "./IdeaList.vue?vue&type=style&index=0&id=ffbc33e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbc33e6",
  null
  
)

export default component.exports